/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'
import Modal from '../../../components/Modal'

/*
 * Props
 *
 * show
 * primaryBtnPressed
 * ghostBtnPressed
 */

export default class Sensors extends Component {

    render() {

        return (
            <div className="Sensors">
                <Modal title="Can't find Tracer data" open={this.props.show} hideCloseBtn={true}>
                    <div className="content">
                        <p>Hmm, I can&apos;t find your Tracer data. There are few possible things that went wrong.</p>
                        <ol>
                            <li>Did you connect and upload your Trace Case successfully?</li>
                            <li>Are you sure you entered the correct game date and time?</li>
                        </ol>
                        <p>Please try to correct these errors and try again. If you are still having problems contact support.</p>
                    </div>
                    <div className="buttons">
                        <button type="button" className="trace-input" onClick={this.props.primaryBtnPressed}>No, I&apos;ll fix it</button>
                    </div>
                    <div className="buttons">
                        <button type="button" className="trace-input ghost" onClick={this.props.ghostBtnPressed}>Yes, continue</button>
                    </div>
                </Modal>
            </div>
        )
    }
}
